// src/lib/dashboard/filtrarFaturasPorPeriodo.ts
//
// Recorta as faturas pelo período do Painel Executivo, na base de data escolhida.
//
// A base (referência / vencimento / emissão) e o que cada uma significa moram em
// `src/lib/financeiro/baseDataFatura.ts` — a série mensal usa as mesmas peças, e
// filtro e série TÊM de concordar. Reexportadas aqui porque a tela importa a
// base deste módulo desde o primeiro dia.
//
// Função pura, sem I/O nem JSX: roda sob `node --test` com type-stripping.

import type { FaturaPainel } from '../financeiro/types.ts';
import type { PeriodoDashboard } from './periodoDashboard.ts';
import { calcularJanelaPeriodoDashboard } from './periodoDashboard.ts';
import { mesRefNaJanela } from '../financeiro/periodo.ts';
import { dataDaBase, dataNaJanela } from '../financeiro/baseDataFatura.ts';
import type { BaseDataFinanceiro } from '../financeiro/baseDataFatura.ts';

export type { BaseDataFinanceiro };
export {
  dataDaBase,
  dataNaJanela,
  mesDaBase,
  DESCRICOES_BASE_DATA,
  ROTULOS_BASE_DATA,
  SEM_DATA,
} from '../financeiro/baseDataFatura.ts';

export function filtrarFaturasPorPeriodo(
  dados: FaturaPainel[],
  periodo: PeriodoDashboard,
  hoje: Date,
  base: BaseDataFinanceiro = 'referencia',
): FaturaPainel[] {
  const janela = calcularJanelaPeriodoDashboard(periodo, hoje);
  // "Todo o histórico" (janela nula) é o mesmo conjunto nas três bases: o
  // recorte não existe, e excluir fatura por falta de data de emissão ali seria
  // esconder faturamento real de um filtro que não pediu recorte nenhum.
  if (!janela) return dados;
  if (base === 'referencia') return dados.filter((f) => mesRefNaJanela(f.mes_referencia, janela));
  return dados.filter((f) => dataNaJanela(dataDaBase(f, base), janela));
}
